import { useState, useMemo } from 'react';
import './workloadVulnerabilitySideoverlay.scss';
// import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import isBoolean from 'lodash/isBoolean';
import isObject from 'lodash/isObject';

import workload12 from '@assets/svg/icons/workload2.svg';
import { Box, Chip } from '@mui/material';
import DateFormatPipe from '@root/components/utilities/DateFormatPipe';
import { capitalizeFirstLetter } from '@root/utilities/string';
import ContentBox from '@root/components/v2/content/ContentBox';
import Loader from '@root/components/common/Loader';
import CircularCloseButton from '@root/components/v2/ui-elements/CircularCloseButton';
import RuntimeAnalysis from './runtimeAnalysis';
import SideOverlayTabMenu, { SideOverlayBody } from '@root/components/v2/SideOverlayTabMenu';
import { WORKLOAD_VULNERABILITY_MENU_CATEGORIES } from './workloadVulnerabilityTabMenu';

const StackedVulnerabilitiesSideOverlay = props => {
  // let disableRemoveTagsButton = false;
  const { selectedRow, isFetchingWorkloadsDetails, onClose, workLoadId } = props;
  const [currentSubTab, setCurrentSubTab] = useState('Details');

  const detailValue = useMemo(() => {
    if (isFetchingWorkloadsDetails) return {};
    if (selectedRow) {
      return selectedRow;
    }
  }, [isFetchingWorkloadsDetails, selectedRow]);

  const detailsKey = useMemo(() => {
    if (isFetchingWorkloadsDetails) return [];
    if (selectedRow) {
      const _data = selectedRow || {};

      return Object.keys(_data)?.filter(
        k =>
          k !== 'account_id' &&
          k !== 'vulnerability_counts' &&
          k !== 'workloads' &&
          k !== 'vulnerabilities' &&
          k !== 'layers' &&
          k !== 'images' &&
          k !== 'affected_workloads' &&
          k !== 'affected_artifacts' &&
          k !== 'affected_images' &&
          k !== 'affected_workloads_count' &&
          k !== 'affected_artifacts_count' &&
          k !== 'affected_images_count' &&
          k !== 'related_artifacts' &&
          k !== 'related_images' &&
          k !== 'artifacts' &&
          k !== 'related_workloads' &&
          k !== 'urls' &&
          k !== 'id' &&
          k !== 'cluster' &&
          k !== 'cve_id' &&
          k !== 'cvss_score' &&
          k !== 'cvss_vector' &&
          k !== 'discovered_at' &&
          k !== 'fix_state' &&
          k !== 'fix_version' &&
          k !== 'impact_score' &&
          k !== 'last_modified' &&
          k !== 'last_updated' &&
          k !== 'risk_spotlight' &&
          k !== 'status',
      );
    }
  }, [isFetchingWorkloadsDetails, selectedRow]);

  // A Sheet hosts this overlay now, so it fills its host instead of placing
  // itself: the two `Resources__Backdrop2` layers it used to draw were
  // full-viewport click-catchers left over from the standalone drawer.
  return (
    <div className="stackedSideoveralyVulnerabilities">
      <div className="Resources__DataSidebar2">
        <div className="Resources__SidebarHeader">
          <div style={{ display: 'flex', paddingTop: '12px', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
              <div style={{ display: 'flex' }}>
                <img src={workload12} />
                <span
                  className="text font-16 weight-700"
                  style={{
                    marginLeft: '10px',
                    color: 'var(--secondary-500)',
                    lineHeight: 1,
                  }}>
                  {selectedRow?.cve_id ?? selectedRow?.vulnerability_id}
                </span>
                {/* <Box flex={1} width={'1100px'} /> */}
              </div>
              <span
                style={{
                  marginLeft: '40px',
                  marginTop: '-12px',
                  // color: 'var(--secondary-400)',
                  fontSize: '12px',
                  fontWeight: 500,
                }}>
                Common Vulnerability and Exposures
              </span>
            </div>
            <Box display={'flex'} alignItems={'center'} gap={'10px'}>
              <CircularCloseButton onClick={() => onClose()} />
            </Box>
          </div>

          <div
            className="text font-16 weight-600"
            style={{
              color: 'var(--secondary-600)',
              paddingLeft: '10px',
            }}>
            {selectedRow?.service}
          </div>
        </div>

        <div className="Resources__SidebarContent">
          <SideOverlayBody
            menu={
              <SideOverlayTabMenu
                categories={WORKLOAD_VULNERABILITY_MENU_CATEGORIES}
                activeTab={currentSubTab}
                onChange={setCurrentSubTab}
                ariaLabel="Workload vulnerability details sections"
              />
            }>
            {/* Lays out the tab body; the scrolling (and the CustomScrollbar styling that goes with it) belongs to
                the card inside. */}
            <div className="Resources__SidebarTabContent">
              {currentSubTab === 'Details' ? (
                isFetchingWorkloadsDetails ? (
                  <div style={{ width: '100%', flex: 1, minHeight: 0, padding: '15px' }}>
                    <Loader />
                  </div>
                ) : (
                  // Fills the space the sub-tabs leave and hands it to the card, so
                  // the card is the only thing that scrolls.
                  <Box
                    display={'flex'}
                    flexDirection={'column'}
                    paddingBottom={'24px'}
                    gap={'15px'}
                    style={{ flex: 1, minHeight: 0 }}>
                    <ContentBox height={'100%'} overflowY={'auto'} containerClassName="CustomScrollbar">
                      {detailsKey?.map(k => {
                        const formattedKey = k
                          .split('_')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ');

                        return (
                          <div
                            key={k}
                            style={{
                              display: 'flex',
                              marginBottom: '8px',
                              fontSize: '13px',
                              alignItems: 'center',
                            }}>
                            <span
                              style={{
                                fontWeight: '600',
                                color: 'rgb(85, 85, 85)',
                                marginRight: '8px',
                                minWidth: '150px',
                                fontSize: '14px',
                                width: '12%',
                              }}>
                              {formattedKey}:
                            </span>
                            <span style={{ flex: 1, color: '#484d56' }}>
                              {k === 'status' ? (
                                <Chip
                                  label={detailValue[k] === 'active' ? 'Active' : detailValue[k]}
                                  sx={{
                                    fontSize: '12px',
                                    fontWeight: '400',
                                    fontFamily: 'Manrope',

                                    height: '20px',
                                    color: detailValue[k] === 'active' ? '#0d5230' : '#FF6A7C',
                                    backgroundColor: detailValue[k] === 'active' ? '#acf3d9' : '#FF6A7C',
                                    // border: '1px solid #F62121',
                                    borderRadius: '8px',
                                  }}
                                />
                              ) : k === 'last_updated' || k === 'last_modified' || k === 'discovered_at' ? (
                                DateFormatPipe(detailValue[k])
                              ) : isNumber(detailValue[k]) || isBoolean(detailValue[k]) || isObject(detailValue[k]) ? (
                                capitalizeFirstLetter(JSON.stringify(detailValue[k]))
                              ) : (
                                (detailValue[k] ?? '-')
                              )}
                            </span>
                          </div>
                        );
                      })}
                    </ContentBox>
                  </Box>
                )
              ) : currentSubTab === 'Runtime Analysis' ? (
                <div
                  className="CustomScrollbar"
                  style={{ paddingBottom: '24px', flex: 1, minHeight: 0, overflow: 'auto' }}>
                  <RuntimeAnalysis selectedRow={selectedRow} workLoadId={workLoadId} />
                </div>
              ) : (
                ''
              )}
            </div>
          </SideOverlayBody>
        </div>
      </div>
    </div>
  );
};
export default StackedVulnerabilitiesSideOverlay;
